/**
 * @description
 * Helps convert hexadecimal color to RGB
 * @param {String} hexColor string of the hexadecimal color
 * @returns {Array} an array of RGB values (eg: [255, 255, 255])
 */
const convertHexColorToRGB = hexColor => {
    if (typeof hexColor !== 'string') {
        hexColor.toString();
    }
    if (hexColor.startsWith('#') && hexColor.length === 7) {
        const hexColorWithoutHashtag = hexColor.substring(1);
        const hexColorValuesToArray = hexColorWithoutHashtag.match(/.{2}/g);
        const hexColorValuesToRGB = hexColorValuesToArray.map(hexValue => parseInt(hexValue, 16));

        return hexColorValuesToRGB;
    }
    return null;
};

/**
 * @description
 * Find the right font color according to a background color's brightness
 * based on algorithm provided by W3C recommandations
 * "Ensure that foreground and background color combinations provide sufficient contrast
 * when viewed by someone having color deficits or when viewed on a black and white screen"
 * source : https://www.w3.org/TR/AERT/#color-contrast
 * @param {String} hexColor string of the hexadecimal color
 * @returns {String} string of hexadecimal value (eg: '#000000')
 */
const getTextColor = (hexColor) => {
    const rgbValuesArray = convertHexColorToRGB(hexColor);
    if (rgbValuesArray) {
        const brightness = Math.round(
            (
                (rgbValuesArray[0] * 299) +
                (rgbValuesArray[1] * 587) +
                (rgbValuesArray[2] * 114)
            ) / 1000
        );

        return brightness > 125 ? '#000000' : '#FFFFFF';
    }
    return '#000000';
};

export { convertHexColorToRGB, getTextColor };